import { useMemo } from "react";

import OptInEventEmitter from "./OptInEventEmitter";
import { envLocker } from "../../reducers/environments";
import useAccountMetadata from "../../hooks/useAccountMetadata";

export default function useOptInEventEmitter() {
  const accountMetadata = useAccountMetadata();

  return useMemo(() => {
    return new OptInEventEmitter(accountMetadata, envLocker);
  }, [accountMetadata]);
}
